import { atom } from "jotai";
import { getCookie } from "../../../_helper/utils/utils";
const storedDayCycle = getCookie("dayCycle");

export const dateAtom = atom(new Date());
export const activeButtonState = atom(storedDayCycle || "day");
export const dayCycleAtom = atom(storedDayCycle || "day");
export const isOnlineAtom = atom(false);
export const loadingAtom = atom(false);
